import React from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import { flatten } from '../../utils/array';
import { translate, prefix } from '../../utils/locale';
import { titleCase } from '../../utils/string';
import s from './Breadcrumbs.scss';

const Breadcrumbs = ({ variantClasses = [], currentPath, filter, filtering, data, setup, resetFilter, product = false }) => {
	let clearFilterBaseSections = flatten(
		filter.clearFilterBase.reduce(
			(acc, base) => [
				...acc,
				...Object.keys(base).map(
					(baseValues) => (Array.isArray(base[baseValues]) ? base[baseValues].map((bV) => bV.split('/')) : baseValues),
				),
			], [],
		),
	);

	clearFilterBaseSections = clearFilterBaseSections.map((campaignTranslate) => {
		if (campaignTranslate === 'productsOnSale') return translate(setup, 'filterSaleUri');
		if (campaignTranslate === 'newProducts') return translate(setup, 'filterNewUri');
		return campaignTranslate;
	});

	const pathSections = currentPath.split('/');
	if (pathSections[0] !== clearFilterBaseSections[0]) clearFilterBaseSections.unshift(pathSections[0]);
	const isLocalized = filtering.localized[setup.language];
	const categoryTitles = isLocalized ? Object.keys(filtering.filterArrays.categories).reduce((acc, category) => {
		const categoryKey = isLocalized?.categories?.[category] ? isLocalized.categories[category].key : category;
		const categoryDescription = isLocalized?.categories?.[category] ? isLocalized.categories[category].description : filtering.filterDescriptions.categories[category];
		return ({ ...acc, [categoryKey]: categoryDescription });
	}, {}) : filtering.filterDescriptions.categories;

	const resetFilterHandler = () => {
		resetFilter();
	};

	let classes = [s.breadcrumbs];
	if (variantClasses) classes = [...classes, ...(Array.isArray(variantClasses) ? variantClasses.map((c) => s[c]) : [s[variantClasses.toString()]])];

	return (
		<div className={classes.join(' ')}>
			<Link className={s.breadcrumbs_link} onClick={resetFilterHandler} to={prefix(setup, '/')}>{ translate(setup, 'home') }</Link>
			{
				clearFilterBaseSections.map((uri, i) => {
					if (pathSections.indexOf(uri) === -1) return null;
					const breadcrumbPath = pathSections.reduce((acc, path, j) => (i >= j ? `${acc}/${path}` : acc), '').slice(1);
					let title = '';

					if (data.baseType === 'brands' && translate(setup, 'designersUri', 'listings').text === uri) {
						title = translate(setup, 'designersTitle', 'listings');
					} else if ((i === pathSections.length - 1 || i === 0) && translate(setup, 'filterNewUri') === uri) {
						title = translate(setup, 'filterNew');
					} else if ((i === pathSections.length - 1 || i === 0) && translate(setup, 'filterSaleUri') === uri) {
						title = translate(setup, 'filterSale');
					} else if (data.baseType === 'brands' && i === 1) {
						title = filtering.filterDescriptions.brands[uri] ? filtering.filterDescriptions.brands[uri] : titleCase(uri);
					} else if (data.baseType === 'brands' && i > 1) {
						title = categoryTitles[breadcrumbPath.split('/').slice(2).join('/')];
					} else {
						title = categoryTitles[breadcrumbPath];
					}

					if (!title) {
						title = categoryTitles[breadcrumbPath.split('/').slice(1).join('/')];
					}

					return <Link key={breadcrumbPath} className={s.breadcrumbs_link} onClick={resetFilterHandler} to={prefix(setup, breadcrumbPath)}>{ title }</Link>;
				})
			}
			{ product && <Link className={s.breadcrumbs_link} to={prefix(setup, product.canonicalUri)}>{ product.name }</Link> }
		</div>
	);
};

export default hot(module)(Breadcrumbs);
